import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PatientStatusEnum {
    active = 1,
    discharged = 2,
    pending = 3,
    nonadmitted = 4,
    deprecated = 5,
    referral = 6,
    hospitalized = 7,
    deceased = 8
}

export enum PatientStatusNameEnum {
    active = "active",
    discharged = "discharged",
    Discharged = "Discharged",
    Discharge = "Discharge",
    pending = "pending",
    nonadmitted = "nonadmitted",
    NonAdmitted = "Non-Admitted",
    NotAdmitted = "Not Admitted",
    NonAdmit = "NonAdmit",
    NonAdmission = "NonAdmission",
    deprecated = "deprecated",
    referral = "referral",
    hospitalized = "hospitalized",
    deceased = "deceased"
}

export class PatientStatusEnumClass extends EnumWithDescription<PatientStatusEnum> {
    public readonly enum = PatientStatusEnum;
    public readonly enumName: string = "PatientStatus";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PatientStatusEnum>> = new Map([
        [
            "active",
            {
                value: PatientStatusEnum.active,
                name: "active"
            }
        ],
        [
            "discharged",
            {
                value: PatientStatusEnum.discharged,
                name: "discharged"
            }
        ],
        [
            "pending",
            {
                value: PatientStatusEnum.pending,
                name: "pending"
            }
        ],
        [
            "nonadmitted",
            {
                value: PatientStatusEnum.nonadmitted,
                name: "non-admitted"
            }
        ],
        [
            "deprecated",
            {
                value: PatientStatusEnum.deprecated,
                name: "deprecated"
            }
        ],
        [
            "referral",
            {
                value: PatientStatusEnum.referral,
                name: "referral"
            }
        ],
        [
            "hospitalized",
            {
                value: PatientStatusEnum.hospitalized,
                name: "hospitalized"
            }
        ],
        [
            "deceased",
            {
                value: PatientStatusEnum.deceased,
                name: "deceased"
            }
        ]
    ]);
}

export const PatientStatus = new PatientStatusEnumClass();
